import 'es6-promise/auto'

import Vue from 'vue'
import App from './components/App.vue'
import router from './router/main'
import store from './store/index'
import PostComment from "./components/KnowledgeBase/PostComment";
import PostComments from "./components/KnowledgeBase/PostComments";
//import './registerServiceWorker'

import _ from 'lodash';
Object.defineProperty(Vue.prototype, '$_', { value: _ });

/*
const UNIQUE_KEY_PROP = '__unique_key_prop__'
const KEY_PREFIX = '__key_prefix__' + Date.now() + '_'
let uid = 0

const isObject = val => val !== null && typeof val === 'object'

const genUniqueKey = obj => {
    if (isObject(obj)) {
        if (UNIQUE_KEY_PROP in obj) {
            return obj[UNIQUE_KEY_PROP]
        }
        const value = KEY_PREFIX + uid++
        Object.defineProperty(obj, UNIQUE_KEY_PROP, { value })
        return value
    }
    return obj
}
*/

const genKey = () => {
    return `f${(~~(Math.random()*1e8)).toString(16)}`;
}

Vue.mixin({
    methods: { genKey }
})

Vue.config.productionTip = false;
Vue.component('post-comments', PostComments);
Vue.component('post-comment', PostComment);

const menu = [
    {
        name: 'home',
        title: 'Главная',
        icon: '',
        cssClass: 'home-component',
        show: false,
        disabled: false
    },
    {
        name: 'login-page',
        title: 'Вход',
        icon: '',
        cssClass: 'introductory-view',
        show: false,
        disabled: false
    },
    {
        name: 'check-lists',
        title: 'Чек-листы',
        icon: '<svg width="18" height="20" viewBox="0 0 18 20"><path\n' +
        '                                  d="M15,8,13.59,6.58,7,13.17,4.41,10.59,3,12l4,4Zm1-6H11.82A3,3,0,0,0,6.18,2H2a1.75,1.75,0,0,0-.4,0A2,2,0,0,0,.16,3.23,1.93,1.93,0,0,0,0,4V18a2.05,2.05,0,0,0,.16.78,2.12,2.12,0,0,0,.43.64,2,2,0,0,0,1,.55A2.6,2.6,0,0,0,2,20H16a2,2,0,0,0,2-2V4A2,2,0,0,0,16,2ZM9,1.75a.75.75,0,1,1-.75.75A.76.76,0,0,1,9,1.75ZM16,18H2V4H16Z"\n' +
        '                                  fill="#fff"/></svg>',
        cssClass: '',
        show: true,
        disabled: true,
        //disabled: false
    },
    {
        name: 'knowledge-base',
        title: 'База знаний',
        icon: '<svg width="16" height="20" viewBox="0 0 16 20">\n' +
        '                              <path d="M14 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.9 20 2 20H14C15.1 20 16 19.1 16 18V2C16 0.9 15.1 0 14 0ZM5 2H7V7L6 6.25L5 7V2ZM14 18H2V2H3V11L6 8.75L9 11V2H14V18Z"\n' +
        '                                    fill="#fff"/>\n' +
        '                          </svg>',
        cssClass: 'knowledge-base-component',
        show: true,
        disabled: false
    },
    {
        name: 'training',
        title: 'Обучение',
        icon: '<svg width="22" height="18" viewBox="0 0 22 18">\n' +
        '                              <path d="M11 0L0 6L4 8.18V14.18L11 18L18 14.18V8.18L20 7.09V14H22V6L11 0ZM17.82 6L11 9.72L4.18 6L11 2.28L17.82 6ZM16 12.99L11 15.72L6 12.99V9.27L11 12L16 9.27V12.99Z"\n' +
        '                                    fill="#fff"/>\n' +
        '                          </svg>',
        cssClass: '',
        show: true,
        disabled: true
        //disabled: false
    },
    {
        name: 'documents',
        title: 'Документы',
        icon: '<svg width="16" height="20" viewBox="0 0 16 20">\n' +
        '                              <path d="M4 14H12V16H4V14ZM4 10H12V12H4V10ZM10 0H2C0.9 0 0 0.9 0 2V18C0 19.1 0.89 20 1.99 20H14C15.1 20 16 19.1 16 18V6L10 0ZM14 18H2V2H9V7H14V18Z"\n' +
        '                                    fill="#fff"/>\n' +
        '                          </svg>',
        cssClass: 'home-component',
        show: true,
        disabled: true
        //disabled: false
    },
    {
        name: 'faq',
        title: 'Вопрос-ответ',
        icon: '<svg width="20" height="20" viewBox="0 0 20 20">\n' +
        '                              <path d="M13 2V9H3.17L2.58 9.59L2 10.17V2H13ZM14 0H1C0.45 0 0 0.45 0 1V15L4 11H14C14.55 11 15 10.55 15 10V1C15 0.45 14.55 0 14 0ZM19 4H17V13H4V15C4 15.55 4.45 16 5 16H16L20 20V5C20 4.45 19.55 4 19 4Z"\n' +
        '                                    fill="#fff"/>\n' +
        '                          </svg>',
        cssClass: 'faq-component',
        show: true,
        disabled: true
        //disabled: false
    },
    {
        name: 'people',
        title: 'Люди',
        icon: '<svg width="18" height="18" viewBox="0 0 18 18">\n' +
        '                              <path d="M16 2V16H2V2H16ZM16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM9 9C7.35 9 6 7.65 6 6C6 4.35 7.35 3 9 3C10.65 3 12 4.35 12 6C12 7.65 10.65 9 9 9ZM9 5C8.45 5 8 5.45 8 6C8 6.55 8.45 7 9 7C9.55 7 10 6.55 10 6C10 5.45 9.55 5 9 5ZM15 15H3V13.47C3 10.97 6.97 9.89 9 9.89C11.03 9.89 15 10.97 15 13.47V15ZM5.31 13H12.69C12 12.44 10.31 11.88 9 11.88C7.69 11.88 5.99 12.44 5.31 13Z"\n' +
        '                                    fill="#fff"/>\n' +
        '                          </svg>',
        cssClass: 'humans-component',
        show: true,
        //disabled: false
        disabled: true
    },
    {
        name: 'home',
        title: 'Главная',
        icon: '',
        cssClass: 'home-component',
        show: false,
        disabled: true
    },
    {
        name: 'not-found',
        title: '404',
        icon: '',
        cssClass: 'error-component',
        show: false,
        disabled: true
    },
];

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<app :menu="menu"></app>',
    methods: {
        toggleHtmlClass(addRemoveClass, className) {
            const el = document.getElementsByTagName( 'html' )[0];
            if (addRemoveClass === 'addClass') {
                el.classList.add(className);
            } else {
                el.classList.remove(className);
            }
        },
    },
    computed: {
        menu() {
            return menu
        }
    },
    mounted() {
        /*Detect IE*/
        let ua = window.navigator.userAgent;
        let msie = ua.indexOf('MSIE');
        let trident = ua.indexOf('Trident/');
        let edge = ua.indexOf('Edge/');
        if(msie > 0){
            this.toggleHtmlClass('addClass', 'ie');
        }
        else if(trident > 0){
            this.toggleHtmlClass('addClass', 'ie');
        }
        else if(edge > 0){
            this.toggleHtmlClass('addClass', 'edge');
        }
        else{
            this.toggleHtmlClass('addClass', 'not-ie');
        }

        /*Detect ios*/
        let mac = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);

        if(mac){
            this.toggleHtmlClass('addClass', 'ios');
        }

        /*Detect Android*/
        let uAgent = navigator.userAgent.toLowerCase();
        let isAndroid = uAgent.indexOf("android") > -1; //&& ua.indexOf("mobile");
        if (isAndroid) {
            this.toggleHtmlClass('addClass', 'android');
        }
        else {
            this.toggleHtmlClass('addClass', 'not-android');
        }
    },
    destroyed() {
        this.toggleHtmlClass('removeClass', 'ios');
    }
});




